import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getAllMonthly = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = "";
  if (params.search)
    url = `/admin/employee-monthly-targets?page=${page}&size=${size}&emp_id_search=${params.search}`;
  else url = `/admin/employee-monthly-targets?page=${page}&size=${size}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const addNewMonthly = async (formData: any): Promise<any> => {
  let url = `/admin/employee-monthly-targets`;
  const response = await axios.post<any>(url, formData, {
 headers: getHeader(),
  });
  return response.data;
};

export const addroadnet = async (formData: any): Promise<any> => {
  let url = `/admin/roadnet-sync`;
  const response = await axios.post<any>(url, formData, {
   headers: getHeader(),
  });
  return response.data;
};

export const generateRoadnetRoutePlanning = async (payload: {
  employee_ids: string[];
}): Promise<any> => {
  const url = `/admin/roadnet/route-planning/generate`;
  const response = await axios.post<any>(url, payload, {
    headers: getHeader(),
  });
  return response.data;
};
export const uploadMonthly = async (formData: FormData): Promise<any> => {
  let url = `/admin/employee-monthly-targets/upload`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};
export const deleteMonthly = async (id: number): Promise<any> => {
  let url = `/admin/territory-mappings/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
export const downloadSample = async (): Promise<any> => {
  let url = `/admin/monthly-target-file`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
